module.exports = __webpack_public_path__ + "static/it-outsourcing-untold-truth-5c5ecd92aa72b8bcacbd5dbe998a4f98.jpg";